/* @flow */
import * as React from 'react';

import Heading from 'components/Heading';
import Row from 'components/Row';
import ValuePropConstants from 'constants/ValuePropConstants';
import ValuePropsRow from 'components/ValuePropsRow';

import './styles/OrganizationUpsellHeader.scss';

const TEACHER_VALUE_PROPOSITIONS = [
  ValuePropConstants.ROSTERING_TEACHER,
  ValuePropConstants.LONG_MESSAGES,
  ValuePropConstants.VOICE_CALLS,
];

const ADMIN_VALUE_PROPOSITIONS = [
  ValuePropConstants.ADMINISTRATION,
  ValuePropConstants.ONBOARDING,
  ValuePropConstants.ADMINISTRATOR_COMMUNICATION,
];

type Props = {
  userRole: 'admin' | 'teacher',
};

class OrganizationUpsellHeader extends React.PureComponent<Props> {
  render() {
    const { userRole } = this.props;

    return (
      <header className="OrganizationUpsellHeader">
        <Row size="xxxlarge">
          <div className="OrganizationUpsellHeader-image" />
        </Row>
        <Heading level="1" levelStyle="2">
          Introducing the Remind plan for schools and districts
        </Heading>
        <ValuePropsRow
          valueProps={
            userRole === 'teacher' ? TEACHER_VALUE_PROPOSITIONS : ADMIN_VALUE_PROPOSITIONS
          }
        />
      </header>
    );
  }
}

export default OrganizationUpsellHeader;
